import pidCrypt from 'pidcrypt';
import 'pidcrypt/asn1';
import util from 'pidcrypt/pidcrypt_util';
import 'pidcrypt/rsa';

const ENCRYPTIONKEY_ENDPOINT =
  process.env.GATSBY_ENCRYPTIONKEY_ENDPOINT || 'https://web.ig.com/clientsecurity/encryptionkey';

/**
 * Encrypts a given password using the provided encryption key.
 * @param {string} password - The password to be encrypted.
 * @param {string} encryptionKey - The encryption key used for encryption.
 **/

export const encryptPassword = async (password: string, encryptionKey: string) => {
  const encryptedCandidate = `${password}`;

  const rsa = new pidCrypt.RSA();
  const key = util.decodeBase64(encryptionKey);

  const asn = pidCrypt.ASN1.decode(util.toByteArray(key));
  const tree = asn.toHexTree();
  rsa.setPublicKeyFromASN(tree);

  return util.encodeBase64(util.convertFromHex(rsa.encrypt(encryptedCandidate)));
};

/**
 * Fetches the encryption key from the specified endpoint.
 * @remarks
 * This function makes a GET request to the `ENCRYPTIONKEY_ENDPOINT` and returns the response as JSON.
 * If the response status is not OK (200), an error is thrown with the corresponding status code.
 * @returns {Promise<any>} - A promise that resolves to the fetched encryption key as JSON.
 * @throws {Error} - If the response status is not OK, an error is thrown with the corresponding status code.
 *
 * **/
export async function getEncryptionKey() {
  return fetch(ENCRYPTIONKEY_ENDPOINT).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  });
}
